module.exports = __webpack_public_path__ + "img/Requesting dStatement@3x.eede14ce.png";